import * as ApiManager from './_manager';

export const auth = {
  register: payload => {
    return ApiManager.callApi ('/customer/registration', payload);
  },

  login: payload => {
    return ApiManager.callApi ('/consumer/login', payload);
  },

  getCustomer: payload => {
    return ApiManager.callApi ('/customer/get', payload);
  },

  checkEmail: payload => {
    return ApiManager.callApi ('/consumer/checkEmail', payload);
  },

  loginWithFirebase: payload => {
    return ApiManager.callApi ('/consumer/loginWithFirebase', payload);
  },

  mewOAuthLogin: payload => {
    return ApiManager.callApi ('/consumer/mewOAuthLogin', payload);
  },

  isRegistered: payload => {
    return ApiManager.callApi ('/consumer/isRegistered', payload);
  },

  verifyOTP: payload => {
    return ApiManager.callApi ('/consumer/verifyOTP', payload);
  },

  resendVerification: payload => {
    return ApiManager.callApi ('/consumer/resendVerification', payload);
  },

  loginWithAccessLink: (payload) => {
    return ApiManager.callApi('/consumer/loginWithAccessLink', payload);
  },
  logoutAuthSession: (payload) => {
    return ApiManager.callApi('/guest/company/trigger-auto-logout', payload);
  },
};
